import {AfterViewInit, Component, OnInit} from '@angular/core';
import {
    ControlService,
    IconService,
    InputBoxService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, AfterViewInit {
    constructor(
        private icon: IconService,
        public inputBox: InputBoxService,
        public control: ControlService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngOnInit() {
        this.inputBox.getCheckBox();
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    setIcon(val:  number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }
}
